const originalConsoleError = console.error;

export const filterErrors = () => {
  console.error = (message, ...args) => {
    if (
      typeof message === "string" &&
      message.includes("defaultProps will be removed")
    ) {
      return;
    }
    if (
      typeof message === "string" &&
      message.includes("A text node cannot be a child of a <View>.")
    ) {
      return;
    }
    originalConsoleError.apply(console, [message, ...args]);
  };
};
